export default [
  {
    path: '/user',
    redirect: '/user/dashboard',
    meta: {
      roles: [6]
    },
    component: () => import('../../components/user/Layout'),
    children: [
      {
        path: 'dashboard',
        name: 'user.dashboard',
        component: () => import('../../views/user/Dashboard'),
        meta: {
          roles: [6]
        }
      },
      {
        path: 'orders',
        name: 'user.orders',
        component: () => import('../../views/user/Orders'),
        meta: {
          roles: [6]
        }
      },
      {
        path: 'order-history',
        name: 'user.orderHistory',
        component: () => import('../../views/user/OrderHistory'),
        meta: {
          roles: [6]
        }
      },
      {
        path: 'check-payment/:id',
        name: 'user.checkPayment',
        component: () => import('../../views/user/CheckPayment.vue'),
        meta: {
          roles: [6]
        }
      },
      {
        path: 'profile',
        name: 'user.profile',
        component: () => import('../../views/user/Profile'),
        meta: {
          roles: [6]
        }
      },
      {
        path: 'institution',
        name: 'user.institution',
        component: () => import('../../views/user/Institution'),
        meta: {
          roles: [6]
        }
      },
      {
        path: 'credit',
        name: 'user.credit',
        component: () => import('../../views/user/TopUpCredit'),
        meta: {
          roles: [6]
        }
      }
    ]
  }
]
